import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { useMutation } from "react-apollo-hooks";
import {
  GRU_SAVING_INFO_EDIT_QUERY,
  GRU_SAVING_INFO_DELETE_QUERY,
  GRU_SAVING_INFO_DETAIL_QUERY,
} from "../Queries";
import { useForm } from "react-hook-form";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../Components/Panel/Panel";
import { toast } from "react-toastify";
import { currencyName } from "../../../../Components/User/UserNames";
import ReactMoment from "react-moment";

import WriteStore from "../WriteStore";

export default ({
  history,
  location,
  id,
  commonStatus,
  name,
  currency,
  amount,
  isLocationCheck,
  gruSavingCount,
  gruSavingAmount,
  store,
  createdAt,
  updatedAt,
}) => {
  const [gruSavingInfoEditMutation] = useMutation(GRU_SAVING_INFO_EDIT_QUERY, {
    refetchQueries: () => [
      { query: GRU_SAVING_INFO_DETAIL_QUERY, variables: { id } },
    ],
  });
  const [gruSavingInfoDeleteMutation] = useMutation(
    GRU_SAVING_INFO_DELETE_QUERY
  );

  const { register, handleSubmit, errors, watch } = useForm({
    defaultValues: {
      commonStatus,
      amount: String(amount),
      isLocationCheck: isLocationCheck ? "true" : "false",
    },
  });

  const [nextStore, setNextStore] = useState({
    value: store.id,
    label: store.name,
    hasLocation: !!(store.longitude && store.latitude),
  });

  const watchedAmount = watch("amount");
  const watchedIsLocationCheck = watch("isLocationCheck");

  const nfcPayload = `N-${id}`;
  const namePreview =
    nextStore && watchedAmount
      ? `${nextStore.label} ${Number(watchedAmount).toLocaleString()}${currencyName(
          currency
        )} 적립`
      : name;

  const onCopyId = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(nfcPayload);
    }
    toast.success("NFC 기록값이 복사되었습니다.");
  };

  const onSubmit = async (data) => {
    if (!nextStore) {
      return toast.error("가맹점을 선택해주세요.");
    }
    if (!Number(data.amount) || Number(data.amount) <= 0) {
      return toast.error("적립 금액을 확인해주세요.");
    }
    if (data.isLocationCheck === "true" && !nextStore.hasLocation) {
      return toast.error(
        "선택한 가맹점에 좌표가 없어 위치 검증을 사용할 수 없습니다."
      );
    }

    try {
      const {
        data: { AdminGruSavingInfoEdit },
      } = await gruSavingInfoEditMutation({
        variables: {
          id,
          store: nextStore.value,
          amount: Number(data.amount),
          currency,
          isLocationCheck: data.isLocationCheck === "true",
          commonStatus: data.commonStatus,
        },
      });
      if (AdminGruSavingInfoEdit) {
        toast.success("처리 되었습니다.");
        history.push(`/gruSavings${location.search}`);
      }
    } catch (e) {
      console.log(e);
      let errorMessage = "에러가 발생했습니다. 다시 시도해 주세요.";
      if (e.graphQLErrors && e.graphQLErrors.length > 0) {
        errorMessage = e.graphQLErrors.map((err) => err.message).join("\n");
      }
      toast.error(errorMessage);
    }
  };

  const onDelete = async () => {
    if (
      !window.confirm(
        "삭제하시겠습니까?\n적립내역이 있으면 삭제 대신 중지 처리됩니다."
      )
    ) {
      return;
    }
    try {
      const {
        data: { AdminGruSavingInfoDelete },
      } = await gruSavingInfoDeleteMutation({ variables: { id } });
      if (AdminGruSavingInfoDelete) {
        toast.success("처리 되었습니다.");
        history.push(`/gruSavings${location.search}`);
      }
    } catch (e) {
      console.log(e);
      toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
    }
  };

  return (
    <>
      <Helmet>
        <title>적립정보 수정 | 한밭페이</title>
      </Helmet>
      <form className="margin-bottom-0" onSubmit={handleSubmit(onSubmit)}>
        <div>
          <ol className="breadcrumb float-xl-right">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Home</Link>
            </li>
            <li className="breadcrumb-item active">
              <Link to={`/gruSavings${location.search}`}>NFC 적립</Link>
            </li>
            <li className="breadcrumb-item active">수정</li>
          </ol>
          <h1 className="page-header">NFC 적립</h1>

          <div className="row m-b-15">
            <div className="col-xs-6 text-left">
              <div className="btn-group">
                <Link
                  to={`/gruSavings${location.search}`}
                  className="btn btn-white"
                >
                  목록
                </Link>
                <Link
                  to={`/gruSavingList?gruSavingInfo=${id}`}
                  className="btn btn-white"
                >
                  적립내역
                </Link>
              </div>
            </div>
            <div className="col-xs-6 text-right">
              <div className="btn-group">
                <button
                  type="button"
                  className="btn btn-white text-danger"
                  onClick={onDelete}
                >
                  <i className="fa fa-trash m-r-5"></i>삭제
                </button>
                <button type="submit" className="btn btn-white text-success">
                  <i className="fa fa-check m-r-5"></i>수정
                </button>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-12">
              <Panel>
                <PanelHeader noButton={true}>NFC 태그 기록값</PanelHeader>
                <PanelBody>
                  <div className="form-group row">
                    <label className="col-form-label col-md-3">기록값</label>
                    <div className="col-md-9">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          value={nfcPayload}
                          readOnly
                        />
                        <span className="input-group-append">
                          <button
                            type="button"
                            className="btn btn-white"
                            onClick={onCopyId}
                          >
                            복사
                          </button>
                        </span>
                      </div>
                      <div className="text-muted f-s-12 m-t-5">
                        NFC Tools 등에서 <b>NDEF 텍스트 레코드</b>로 위 값을 그대로
                        기록하세요. 기록값은 변경할 수 없습니다.
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-form-label col-md-3">적립 실적</label>
                    <div className="col-md-9">
                      <span className="form-control-static">
                        {(gruSavingCount || 0).toLocaleString()}건 /{" "}
                        {(gruSavingAmount || 0).toLocaleString()}
                        {currencyName(currency)}
                        <span className="text-muted f-s-12 m-l-10">
                          (취소분 제외)
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-form-label col-md-3">등록/수정</label>
                    <div className="col-md-9">
                      <span className="form-control-static text-muted f-s-12">
                        <ReactMoment format="YYYY-MM-DD HH:mm:ss">
                          {createdAt}
                        </ReactMoment>
                        {" / "}
                        <ReactMoment format="YYYY-MM-DD HH:mm:ss">
                          {updatedAt}
                        </ReactMoment>
                      </span>
                    </div>
                  </div>
                </PanelBody>
              </Panel>

              <Panel>
                <PanelHeader noButton={true}>적립정보</PanelHeader>
                <PanelBody>
                  <div className="form-group row">
                    <label className="col-form-label col-md-3">상태</label>
                    <div className="col-md-9">
                      <div className="radio radio-css radio-inline">
                        <input
                          type="radio"
                          id="commonStatusC"
                          name="commonStatus"
                          className="form-control m-b-5"
                          value="C"
                          ref={register({
                            required: "상태를 선택해주세요.",
                          })}
                        />
                        <label htmlFor="commonStatusC">사용</label>
                      </div>
                      <div className="radio radio-css radio-inline">
                        <input
                          type="radio"
                          id="commonStatusS"
                          name="commonStatus"
                          className="form-control m-b-5"
                          value="S"
                          ref={register({
                            required: "상태를 선택해주세요.",
                          })}
                        />
                        <label htmlFor="commonStatusS">중지</label>
                      </div>
                      {errors.commonStatus && (
                        <div>
                          <span>{errors.commonStatus.message}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-form-label col-md-3">
                      적립 가맹점
                    </label>
                    <div className="col-md-9">
                      <WriteStore store={nextStore} setStore={setNextStore} />
                      {nextStore && !nextStore.hasLocation && (
                        <div className="text-muted f-s-12 m-t-5">
                          이 가맹점은 좌표가 등록되어 있지 않아 위치 검증을
                          사용할 수 없습니다.
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-form-label col-md-3">
                      적립 금액({currencyName(currency)})
                    </label>
                    <div className="col-md-9">
                      <input
                        type="number"
                        name="amount"
                        className="form-control m-b-5"
                        style={{ maxWidth: 240 }}
                        placeholder="적립 금액 입력"
                        ref={register({
                          required: "적립 금액을 입력해주세요.",
                        })}
                      />
                      {errors.amount && <span>{errors.amount.message}</span>}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-form-label col-md-3">위치 검증</label>
                    <div className="col-md-9">
                      <div className="radio radio-css radio-inline">
                        <input
                          type="radio"
                          id="isLocationCheckTrue"
                          name="isLocationCheck"
                          className="form-control m-b-5"
                          value="true"
                          ref={register()}
                        />
                        <label htmlFor="isLocationCheckTrue">사용</label>
                      </div>
                      <div className="radio radio-css radio-inline">
                        <input
                          type="radio"
                          id="isLocationCheckFalse"
                          name="isLocationCheck"
                          className="form-control m-b-5"
                          value="false"
                          ref={register()}
                        />
                        <label htmlFor="isLocationCheckFalse">미사용</label>
                      </div>
                      <div className="text-muted f-s-12 m-t-5">
                        사용 시 가맹점 반경 150m 안에서만 적립할 수 있습니다.
                      </div>
                      {watchedIsLocationCheck === "true" &&
                        nextStore &&
                        !nextStore.hasLocation && (
                          <div className="text-danger f-s-12 m-t-5">
                            선택한 가맹점에 좌표가 없습니다.
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-form-label col-md-3">
                      명칭(자동 생성)
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control m-b-5"
                        value={namePreview}
                        readOnly
                      />
                      <div className="text-muted f-s-12">
                        가맹점·금액을 바꾸면 명칭도 함께 다시 만들어집니다.
                      </div>
                    </div>
                  </div>
                </PanelBody>
              </Panel>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};
